import { apiGet } from '../services/api';

export async function getAllBranches() {
  const response = await apiGet('/api/branches');
  return response.data || [];
}

